const backendUrls = {
  https: 'https://neumeet.herokuapp.com/',
  wss: 'wss://neumeet.herokuapp.com/graphql',
};

export default backendUrls;
